import { IAPITimeZoneModel } from "../interfaces";

export class TimeZoneModel {
  id: string;
  name: string;
  abbreviation: string;
  utcHourOffset: number;
  utcMinuteOffset: number;
  countryId: string;
  alternateCountryIds: string[];

  constructor(data?: Partial<TimeZoneModel>) {
    this.id = data?.id || "";
    this.name = data?.name || "";
    this.abbreviation = data?.abbreviation || "";
    this.utcHourOffset = data?.utcHourOffset || 0;
    this.utcMinuteOffset = data?.utcMinuteOffset || 0;
    this.countryId = data?.countryId || "";
    this.alternateCountryIds = data?.alternateCountryIds || [];
  }

  createAPIMap(): IAPITimeZoneModel {
    return {
      id: this.id,
      name: this.name,
      abbreviation: this.abbreviation,
      utcHourOffset: this.utcHourOffset,
      utcMinuteOffset: this.utcMinuteOffset,
      countryId: this.countryId,
      alternateCountryIds: this.alternateCountryIds,
    };
  }

  static deserialize(data: IAPITimeZoneModel): TimeZoneModel {
    const mappedData = {
      id: data.id,
      name: data.name,
      abbreviation: data.abbreviation,
      utcHourOffset: data.utcHourOffset,
      utcMinuteOffset: data.utcMinuteOffset,
      countryId: data.countryId,
      alternateCountryIds: data.alternateCountryIds,
    };
    return new TimeZoneModel(mappedData);
  }
}
